import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMDatePicker from 'src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker';
import moment from 'moment';

type Props = {
  formikProps: FormikProps<any>;
  onClose: () => void;
  onReset :()=>void ;
};

const FranchiseFilterDialog = ({ formikProps, onClose , onReset }: Props) => {
  const { values, setFieldValue } = formikProps;
  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className="flex justify-between items-center sticky top-0 z-50">
          <div className="text-xl font-medium"> Filter </div>
          <button
            type="reset"
            className="text-red-600 hover:text-red-400 font-medium"
            onClick={onReset}
          >
            Clear Filters
          </button>
        </div>

        {/* Created At */}
        <div className="mb-2">
          <div className="text-slate-500 font-medium text-sm"> Created At </div>
          <div className="flex gap-2 items-center">
            {/* From */}
            <div className="w-full">
              <ATMDatePicker
                label="From"
                name="startDate"
                format="DD/MM/YYYY"
                maxDate={moment().format("yyyy-MM-DD")}
                value={values.startDate || null}
                onChange={(newValue) => setFieldValue("startDate", newValue)}
              />
            </div>

            {/* To */}
            <div className="w-full">
              <ATMDatePicker
                label="To"
                name="endDate"
                format="DD/MM/YYYY"
                value={values.endDate|| null}
                minDate={values?.startDate || undefined}
                onChange={(newValue) => setFieldValue("endDate", newValue)}
              />
            </div>
          </div>
        </div>
      <div className='flex flex-col gap-2'>
        <ATMLoadingButton type='submit'>
         Apply
        </ATMLoadingButton>
        <ATMLoadingButton onClick={onClose} className='bg-slate-400' type='submit'>
          Cancel
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default FranchiseFilterDialog;